import React, { createContext, ReactElement, useContext, useEffect, useReducer } from "react";
import Reducer from './Reducer'
import * as Notifications from 'expo-notifications';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { SafeJSONArray } from "../../constants/Utils";
import { PNActionTypes, IPNState } from "../../interfaces/pushNotification";
import { AnalyticsService } from "../../constants/Analytics";
import { AuthContext } from '../auth/Store';

const initialState: IPNState = {
    notifications: []
};

const analytics = new AnalyticsService()

export const NotificationContext = createContext<any>(null);

const NotificationStore = ({ ...props }): ReactElement<any> => {
    const [nState, nDispatch] = useReducer(Reducer, initialState)
    const auth = useContext(AuthContext)
    const buyer = auth.state.buyerData

    const deleteNotification = (identifier: string) => {
        Notifications.dismissNotificationAsync(identifier)
        nDispatch({
            type: PNActionTypes.remove,
            payload: identifier
        })
    }

    useEffect(() => {
        (async function () {
            try {
                const prev = await AsyncStorage.getItem('RN4notifications')
                const notifications = SafeJSONArray(prev)
                nDispatch({
                    type: PNActionTypes.set,
                    payload: notifications
                })
            } catch (e) {
                //
            }
        })()

        const incoming_subscription = Notifications.addNotificationReceivedListener(notification => {
            analytics.logEvent('Received Push Notification', buyer, notification)
            nDispatch({
                type: PNActionTypes.add,
                payload: notification
            })
        });
        const response_subscription = Notifications.addNotificationResponseReceivedListener(notification => {
            analytics.logEvent('Opened Push Notification', buyer, notification.notification)
            nDispatch({
                type: PNActionTypes.add,
                payload: notification.notification
            })
        });

        return () => {
            incoming_subscription.remove();
            response_subscription.remove();
        }
    }, []);

    return (
        <NotificationContext.Provider
            value={{
                notif_state: nState,
                notif_dispatch: nDispatch,
                notif_delete: deleteNotification
            }}
        >
            {props.children}
        </NotificationContext.Provider>
    )
};

export default NotificationStore;